import React from 'react';
import Translate from '../../../../../../../../components/Translate';
import TableAction from '../../../../../../../../components-new/table/TableAction';
import DeleteIcon from '../../../../../../../../assets/icons/DeleteIcon';

/*
 * The bot a channel is connected through, once it is connected.
 *
 * Telegram and Webex each drew this themselves: a picture, a bare name and a
 * literal × in a <span>, spaced by justify-content: space-between so the name
 * floated in the middle of the row with nothing either side of it. Nothing said
 * the × could be pressed until it was.
 *
 * It is a row from the same set every list in the settings screens is built
 * from, and the × is the icon button the tables use - which fills under the
 * pointer, takes the keyboard, and says what it does.
 */
const ConnectedBot = ({name, imageUrl, fallbackIcon, onDelete}) => (
    <div className="stg-list connected-bot">
        <div className="stg-row">
            <span className="connected-bot__avatar">
                {imageUrl ? <img src={imageUrl} alt="" width={40} height={40}/> : fallbackIcon}
            </span>

            <span className="stg-row__text connected-bot__text">
                <span className="connected-bot__name">{name}</span>
                <span className="connected-bot__state"><Translate text="connected"/></span>
            </span>

            <span className="stg-row__actions">
                <TableAction
                    tone="danger"
                    tooltip="delete"
                    icon={<DeleteIcon width={16} height={16} stroke="currentColor"/>}
                    onClick={onDelete}
                />
            </span>
        </div>
    </div>
);

export default ConnectedBot;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/components/ConnectedBot.jsx